import { referralShareCopy, shareReferral } from "./shareReferral";
import "./ReferralShareButtons.css";

const PLATFORMS = [
  { id: "whatsapp", label: "WhatsApp", className: "sc-whatsapp" },
  { id: "instagram", label: "Instagram", className: "sc-instagram" },
  { id: "facebook", label: "Facebook", className: "sc-facebook" },
  { id: "tiktok", label: "TikTok", className: "sc-tiktok" },
  { id: "email", label: "Email", className: "sc-email" },
  { id: "more", label: "More", className: "sc-more" },
];

function ShareIcon({ id }) {
  if (id === "whatsapp") {
    return (
      <svg width="19" height="19" viewBox="0 0 24 24" fill="white" aria-hidden>
        <path d="M17.6 6.3A8.9 8.9 0 0012 4a8.9 8.9 0 00-7.7 13.4L3 21l3.7-1.3A8.9 8.9 0 0012 21a8.9 8.9 0 006.3-15.2zM12 19.5a7.4 7.4 0 01-3.8-1l-.3-.2-2.5.8.8-2.4-.2-.3A7.5 7.5 0 1119.5 12 7.5 7.5 0 0112 19.5z" />
      </svg>
    );
  }
  if (id === "instagram") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="white" />
      </svg>
    );
  }
  if (id === "facebook") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="white" aria-hidden>
        <path d="M22 12a10 10 0 10-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0022 12z" />
      </svg>
    );
  }
  if (id === "tiktok") {
    return (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="white" aria-hidden>
        <path d="M16.6 5.8a4.5 4.5 0 01-2.6-4.5V0h-3.4v16.3a2.6 2.6 0 11-1.8-2.5V10.3a5.9 5.9 0 106.2 5.9V8.1a7.9 7.9 0 004.5 1.4V6a4.5 4.5 0 01-2.9-.2z" />
      </svg>
    );
  }
  if (id === "email") {
    return (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#4A4436" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M22 6l-10 7L2 6" />
        <rect x="2" y="4" width="20" height="16" rx="2" />
      </svg>
    );
  }
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
      <line x1="15.4" y1="6.5" x2="8.6" y2="10.5" />
    </svg>
  );
}

export default function ReferralShareButtons({ url, kind = "fan", displayName, onToast }) {
  const text = referralShareCopy({ kind, displayName });

  return (
    <div className="rf-share-icons">
      {PLATFORMS.map((p) => (
        <button
          key={p.id}
          type="button"
          className={`rf-share-circle ${p.className}`}
          aria-label={p.label}
          onClick={() => shareReferral({ platform: p.id, url, text, onToast })}
        >
          <ShareIcon id={p.id} />
          <span className="rf-share-tooltip">{p.label}</span>
        </button>
      ))}
    </div>
  );
}
